'use strict';

import React, { PropTypes } from 'react';
import Alert from '../organisms/Alert';
import OkayAlert from '../alerts/OkayAlert';
import Icon from '../atoms/Icon';
import ShareActionCreators from '../actions/ShareActionCreators';
import PureRenderMixin from '../mixins/PureRenderMixin';
import Share from '../molecules/Share';
import ServiceTypes from '../constants/ServiceTypes';
import AnalyticsSources from '../constants/AnalyticsSources';
import StampStore from '../stores/StampStore';
import StampStatus from '../constants/StampStatus';
import createStoreMixin from '../mixins/createStoreMixin';
import invariant from 'react/lib/invariant';
import { makeHref } from '../router';
import getStampSegment from '../utils/getStampSegment';

var SharePostedStampAlert = React.createClass({
  mixins: [createStoreMixin(StampStore), PureRenderMixin],

  propTypes: {
    stampId: PropTypes.number.isRequired
  },

  getStateFromStores(props) {
    return {
      stamp: StampStore.get(props.stampId)
    };
  },

  componentWillMount() {
    const { stampId } = this.props;
    invariant(StampStore.contains(stampId), 'Expected stamp %s to exist in store', stampId);
  },

  render() {
    const { stamp } = this.state;

    switch (stamp.status) {
    case StampStatus.PUBLIC:
      return (
        <Alert title='Your Stamp has been posted'
               message='Share your work to give recognition it deserves.'>
          <Share onShareClick={this.handleShareClick}
                 services={[
                   ServiceTypes.FACEBOOK,
                   ServiceTypes.TWITTER,
                   ServiceTypes.GOOGLE
                 ]}
                 size='medium' />
        </Alert>
      );
    case StampStatus.UNLISTED:
      const stampSegment = getStampSegment(stamp);
      const stampLink = window.location.origin + makeHref('feedStamp', {stampSegment: stampSegment});
      const handleClick = (e) => { e.target.select(); };

      return (
        <OkayAlert title='Your Stamp has been posted'
                   message={
                     <span>
                       <Icon name='eyeCrossed'
                             mode='fill'
                             size='medium' />
                       <br />
                       <br />
                       It is visible only to those who have the link.
                       Copy and paste the link below to share it:
                       <br />
                       <br />
                       <input className='FormInput' value={stampLink} readOnly onClick={handleClick} />
                     </span>
                   }
                   buttonText='Got it' />
      );
    }

  },

  handleShareClick(service) {
    ShareActionCreators.shareStamp({
      stampId: this.props.stampId,
      service: service,
      source: AnalyticsSources.ALERT
    });
  }
});

module.exports = SharePostedStampAlert;



/** WEBPACK FOOTER **
 ** ./alerts/SharePostedStampAlert.jsx
 **/